import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';

interface TokenResponse {
  data?: { token?: string };
}

interface MfaMetaResponse {
  data?: {
    expires_in_seconds?: number;
    resend_after_seconds?: number;
    verified?: boolean;
  };
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly tokenKey = 'bfc_token';

  constructor(private http: HttpClient, private router: Router) {}

  login(email: string, password: string) {
    return this.http
      .post<TokenResponse>(`${environment.apiUrl}/auth/token`, { email, password })
      .pipe(
        tap((response) => {
          const token = response?.data?.token;
          if (token) {
            localStorage.setItem(this.tokenKey, token);
          }
        })
      );
  }

  requestMfa(email: string, context: 'auth' | 'athlete' = 'auth') {
    return this.http.post<MfaMetaResponse>(`${environment.apiUrl}/auth/mfa/request`, { email, context });
  }

  verifyMfa(email: string, code: string, context: 'auth' | 'athlete' = 'auth') {
    return this.http
      .post<TokenResponse>(`${environment.apiUrl}/auth/mfa/verify`, { email, code, context })
      .pipe(
        tap((response) => {
          const token = response?.data?.token;
          if (token) {
            localStorage.setItem(this.tokenKey, token);
          }
        })
      );
  }

  logout() {
    localStorage.removeItem(this.tokenKey);
    this.router.navigate(['/login']);
  }

  get token(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  isAuthenticated(): boolean {
    return !!this.token;
  }

  getUserInfo(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/auth/me`);
  }
}

